<template>
    <div class="flex-grid">
        <!-- INFO -->
        <div class="flex-xs-12 flex-md-12 p0">
            <slot v-if="isMobile" name="product-credit" :partner="partner" />
            <template v-if="hasDescription">
                <h2
                    class="h6 text-bold text-uppercase mt font-roboto-c grayColor m0"
                    @click="collapseItens.description = !collapseItens.description"
                >
                    <i
                        class="icon-cr collapsible-icon hidden-md-up"
                        :class="
                            collapseItens.description ? 'icon-chevron-right' : 'icon-chevron-down-2'
                        "
                    ></i>
                    {{ title }}
                </h2>
                <p
                    class="grayColor m0"
                    :class="{ opened: collapseItens.description }"
                    itemprop="description"
                    v-html="$f.removeInlineStyles(product.description)"
                ></p>
            </template>

            <template v-if="$scope.TENANT_IDENTIFIER === 'umapenca' && beCareful">
                <h2
                    class="h6 text-bold text-uppercase mt font-roboto-c grayColor m0"
                    v-if="this.product.type.id === 1 || this.product.type.id === 7"
                    @click="collapseItens.becareful = !collapseItens.becareful"
                >
                    <i
                        class="icon-cr collapsible-icon hidden-md-up"
                        :class="
                            collapseItens.becareful ? 'icon-chevron-right' : 'icon-chevron-down-2'
                        "
                    ></i>
                    Cuidados com a sua camiseta
                </h2>
                <h2
                    class="h6 text-bold text-uppercase mt font-roboto-c grayColor m0"
                    v-else-if="this.product.type.id === 21"
                >
                    <i
                        class="icon-cr collapsible-icon hidden-md-up"
                        :class="
                            collapseItens.becareful ? 'icon-chevron-right' : 'icon-chevron-down-2'
                        "
                    ></i>
                    Cuidados com a sua ecobag
                </h2>
                <p
                    class="grayColor m0"
                    :class="{ opened: collapseItens.becareful }"
                    itemprop="beCareful"
                    v-html="beCareful"
                ></p>
            </template>
        </div>

        <slot v-if="!isMobile" name="product-credit" :partner="partner" />

        <!-- DESCRIPTION -->
        <div class="flex-xs-12 flex-md-6 p0">
            <div class="flex-xs-12 flex-lg-6 p0">
                <h2
                    class="h6 text-bold text-uppercase font-roboto-c grayColor m0"
                    @click="collapseItens.aboutProduct = !collapseItens.aboutProduct"
                >
                    <i
                        class="icon-cr collapsible-icon hidden-md-up"
                        :class="
                            collapseItens.description ? 'icon-chevron-right' : 'icon-chevron-down-2'
                        "
                    ></i>
                    {{ $t('_product.about') }}
                </h2>

                <div
                    class="grayColor m0"
                    :class="{ opened: collapseItens.aboutProduct }"
                    v-if="aboutText"
                    v-html="aboutText"
                />
            </div>
        </div>

        <template v-if="(product.partner || {}).url || product.categories.length > 0">
            <div class="flex-xs-12 flex-lg-6 p0">
                <h3
                    class="h6 text-bold text-uppercase font-roboto-c grayColor m0"
                    @click="collapseItens.relatedProduct = !collapseItens.relatedProduct"
                >
                    <i
                        class="icon-cr collapsible-icon hidden-md-up"
                        :class="
                            collapseItens.relatedProduct
                                ? 'icon-chevron-right'
                                : 'icon-chevron-down-2'
                        "
                    ></i>
                    {{ $t('_product.related') }}
                </h3>
                <div class="grayColor m0" :class="{ opened: collapseItens.relatedProduct }">
                    <ProductCategories id="product-categories-mobile" :product="product" />
                </div>
            </div>
        </template>

        <div
            v-if="product.organization && $scope.TENANT_IDENTIFIER === 'umapenca'"
            class="flex-xs-12 flex-md-6 p0"
        >
            <template>
                <h3
                    class="h6 text-bold text-uppercase font-roboto-c grayColor m0"
                    @click="collapseItens.donation = !collapseItens.donation"
                >
                    <i
                        class="icon-cr collapsible-icon hidden-md-up"
                        :class="
                            collapseItens.donation ? 'icon-chevron-right' : 'icon-chevron-down-2'
                        "
                    ></i>
                    Doação
                </h3>
                <p class="grayColor m0" :class="{ opened: collapseItens.donation }">
                    Parte do valor de venda deste produto é direcionado ao
                    {{ product.organization.name }}, {{ product.organization.description }}
                </p>
            </template>
        </div>
    </div>
</template>

<script>
    import Modal from '../common/container/Modal.vue';
    import ProductAbout from './mixin/ProductAbout.vue';
    import ProductCategories from './ProductCategories.vue';
    import { resizeOrientationAware } from '../../script/common';

    export default {
        name: 'ProductAboutForCustomer',
        components: { Modal, ProductCategories },
        mixins: [ProductAbout],

        props: {
            partner: {
                type: Object,
                required: false,
            },
        },

        data() {
            return {
                collapseItens: {
                    aboutProduct: true,
                    relatedProduct: true,
                    description: true,
                    countdownDeadline: null,
                    becareful: true,
                    donation: true,
                },
                isMobile: false,
            };
        },

        mounted() {
            this.resizeAwareRemoveCb = resizeOrientationAware(() => this.onResize(), true);
        },

        beforeDestroy() {
            this.resizeAwareRemoveCb();
        },

        methods: {
            onResize() {
                this.isMobile = window.innerWidth < 768;
            },
        },
    };
</script>
